export function notTodayPass(time) {
    let today = new Date();
    today.setHours(23);
    today.setMinutes(59);
    today.setSeconds(59);
    if (time.getTime() > today.getTime()) {
        return true;
    }
    return false;
}